import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MyBookingServiceService } from '@common/services/my-booking/my-booking-service/my-booking-service.service';
import { MyBookingServicePresModule } from '../presenter/my-booking-service-pres.module';
import { MyBookingServicesComponent } from './my-booking-services.component';

@NgModule({
  declarations: [MyBookingServicesComponent],
  imports: [CommonModule, MyBookingServicePresModule],
  providers: [MyBookingServiceService],
  exports: [MyBookingServicesComponent],
})
export class MyBookingServicesModule {}
